let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://skyops.moleawiz.com/ws";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://skyops.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://skyops.moleawiz.com"
} else if (environment === "staging") {
  baseUrl =
    "https://skyops.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://skyops.moleawiz.com"
} else {
  baseUrl =
    "https://skyops.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://skyops.moleawiz.com"
}

export { baseUrlOrigin };
export default baseUrl;
